const WINDOW_SIZE = 10;
const STALE_THRESHOLD = 30000;

const THRESHOLDS = {
  GOOD: 400,
  WEAK: 800,
};

export const SIGNALS = {
  GOOD: 'good',
  WEAK: 'weak',
  BAD: 'bad',
  UNKNOWN: 'unknown',
};

class NetworkQuality {
  constructor() {
    this.responseTimes = [];
    this.lastRecordedAt = null;
    this.listeners = new Set();
    this.currentSignal = SIGNALS.GOOD;
  }

  recordResponseTime(durationMs) {
    this.responseTimes.push(durationMs);
    if (this.responseTimes.length > WINDOW_SIZE) {
      this.responseTimes.shift();
    }
    this.lastRecordedAt = Date.now();
    this._updateSignal();
  }

  recordFailure() {
    this.recordResponseTime(Infinity);
  }

  _getMovingAverage() {
    if (this.responseTimes.length === 0) return null;

    const validTimes = this.responseTimes.filter(t => t !== Infinity);
    const failures = this.responseTimes.length - validTimes.length;

    // If more than half the requests failed, connection is bad
    if (failures > this.responseTimes.length / 2) return Infinity;
    if (validTimes.length === 0) return Infinity;

    return validTimes.reduce((a, b) => a + b, 0) / validTimes.length;
  }

  _updateSignal() {
    const avg = this._getMovingAverage();
    let newSignal;

    if (avg === null) {
      newSignal = SIGNALS.UNKNOWN;
    } else if (avg === Infinity || avg > THRESHOLDS.WEAK) {
      newSignal = SIGNALS.BAD;
    } else if (avg > THRESHOLDS.GOOD) {
      newSignal = SIGNALS.WEAK;
    } else {
      newSignal = SIGNALS.GOOD;
    }

    if (newSignal !== this.currentSignal) {
      this.currentSignal = newSignal;
      this._notifyListeners();
    }
  }

  getSignal() {
    if (this.lastRecordedAt && Date.now() - this.lastRecordedAt > STALE_THRESHOLD) {
      return SIGNALS.UNKNOWN;
    }
    return this.currentSignal;
  }

  getMovingAverage() {
    return this._getMovingAverage();
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  _notifyListeners() {
    this.listeners.forEach(listener => listener(this.currentSignal));
  }
}

const networkQuality = new NetworkQuality();
export default networkQuality;
